/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type { PortaleDto } from ".././models";

export const getPortali = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<PortaleDto[]>> => {
  return axios.get(`/api/portali`, options);
};

export const getGetPortaliQueryKey = () => [`/api/portali`] as const;

export const getGetPortaliQueryOptions = <
  TData = Awaited<ReturnType<typeof getPortali>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPortali>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<Awaited<ReturnType<typeof getPortali>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPortaliQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortali>>> = ({
    signal,
  }) => getPortali({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetPortaliQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPortali>>
>;
export type GetPortaliQueryError = AxiosError<unknown>;

export const useGetPortali = <
  TData = Awaited<ReturnType<typeof getPortali>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPortali>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPortaliQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetPortali = () =>
  //@ts-ignore
  useGetPortali(...([] as any[]));
